document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('track-order-form');

  if (form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const awb = document.getElementById('awb-number').value.trim();
      if (!awb) return;
      window.open('https://shiprocket.co/tracking/' + encodeURIComponent(awb), '_blank');
    });
  }
});
